import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';
import 'photoswipe/dist/photoswipe.css';


export default {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    const lightbox = new PhotoSwipeLightbox({
      gallery: '#hitch-image-viewer-gallery',
      pswpModule: PhotoSwipe,
      imageClickAction: 'close',
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      counter: false,
    });
    const getImage = (src) => new Promise((resolve) => {
      const img = new Image();
      img.src = src;
      img.onload = () => resolve(img);
    });
    const open = async (imageUrl) => {
      if (lightbox.pswp) {
        lightbox.pswp.destroy();
      }
      const image = await getImage(imageUrl);
      lightbox.loadAndOpen(0, [
        {
          src: imageUrl,
          width: image.width,
          height: image.height,
        },
      ]);
    };
    const openVideo = (videoUrl) => {
      lightbox.loadAndOpen(0, [{
        html: `<video class="video-viewer" src="${videoUrl}" muted controls></video>`,
      }]);
    };
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$imageViewer = {
      open,
    };
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$videoViewer = {
      openVideo,
    };
  },
};
